export default __webpack_public_path__ + "static/media/1933.bf9085c2.png";